import * as type from './types';
import { updateObject, _sendLog } from "../../utils/utility";

const INITIAL_STATE: type.SystemType = {
    site: '',
    step: 1,
    spinner: false,
    showModal: false,
    modal: {},
    showError: false,
    paynowAvailable: true,
    errors: [],
    systemAvailable: true
};

const setSite = (state: any, action: any) => {
    return updateObject(
        state,
        { site: action.site }
    )
}

const setStep = (state: any, action: any) => {
    return updateObject(
        state,
        { step: action.step }
    )
}

const showModalError = (state: any, action: any) => {
    console.error('showModalError called');
    console.error(action);
    _sendLog(['SME-React - System Reducer - showModalError called', ...action.errors]);
    return updateObject(
        state,
        {
            showError: true,
            errors: action.errors
        }
    )
}

const clearModalError = (state: any, action: any) => {
    return updateObject(
        state,
        {
            showError: false
        }
    )
}

const showModal = (state: any, action: any) => {
    return updateObject(
        state,
        {
            showModal: true,
            modal: action.data
        }
    )
}

const hideModal = (state: any, action: any) => {
    return updateObject(
        state,
        {
            showModal: false
        }
    )
}

const showSpinner = (state: any, action: any) => {
    return updateObject(
        state,
        {
            spinner: true
        }
    )
}

const hideSpinner = (state: any, action: any) => {
    return updateObject(
        state,
        {
            spinner: false
        }
    )
}

const setPaynowAvailable = (state: any, action: any) => {
    return updateObject(
        state,
        { paynowAvailable: action.paynowAvailable }
    )
}

const setSytemAvailable = (state: any, action: any) => {
    return updateObject(
        state,
        { systemAvailable: action.systemAvailable }
    )
}

export function systemReducer(state: type.SystemType = INITIAL_STATE, action: type.ActionType) {
    switch (action.type) {
        case type.SET_SITE:
            return setSite(state, action);
        case type.SET_STEP:
            return setStep(state, action);
        case type.SHOW_ERROR:
            return showModalError(state, action);
        case type.CLEAR_ERROR:
            return clearModalError(state, action);
        case type.SHOW_MODAL:
            return showModal(state, action);
        case type.HIDE_MODAL:
            return hideModal(state, action);
        case type.SHOW_SPINNER:
            return showSpinner(state, action);
        case type.HIDE_SPINNER:
            return hideSpinner(state, action);
        case type.SET_PAYNOW_AVAILABLE:
            return setPaynowAvailable(state, action);
        case type.SET_SYSTEM_AVAILABLE:
            return setSytemAvailable(state, action);
        default:
            return state;
    }
}
